import React, { useState } from 'react';
import UploadButton from './UploadButton';
import Spinner from './Spinner';
import { useNavigate } from "react-router-dom";
import TrustSummaryView from './TrustSummaryView';
import ErrorPage from './ErrorPage';
import './audioTrustPanel.css'

const AudioTrustPanel = () => {
  const [s3Uri, setS3Uri] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleUploadSuccess = (uri) => {
    setS3Uri(uri);
    setError(null);
  };
   const navigate = useNavigate();
  
    const handleNavigate = () => {
      navigate("/"); 
    };

  const handleAnalyze = async () => {
    if (!s3Uri) return;

    setIsAnalyzing(true);
    setResult(null);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/analyze-audio`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ s3_uri: s3Uri }),
      });

      if (!response.ok) {
        throw new Error(`Analysis failed: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("data",data?.live_result)
     setResult(data.live_result);
    } catch (err) {
      console.error('Analysis Error:', err);
      setError(err.message);
    } finally {
      setIsAnalyzing(false);
    }
  };

 return (
  <div className="panel-container">
      {!s3Uri && (
      <div className="upload-wrapper">
        <UploadButton onSuccess={handleUploadSuccess} />
      </div>
    )}
    

    
      {s3Uri && !result && !isAnalyzing && !error &&(
        <div className="button-container">
        <button onClick={handleAnalyze} className="analyze-button">
          Analyze Audio
        </button>
        </div>
      )}
    
      {isAnalyzing && <Spinner />}
    
      {result && (
        <div className="result-container" style={{  color: 'black' }}>
        <TrustSummaryView result={result} />
        </div>
        )}
    

    
      {error && <ErrorPage message={error} />}

      <button onClick={handleNavigate} style={{ padding: "10px 20px", fontSize: "16px" ,cursor:"pointer", backgroundColor:"lightblue" ,marginBottom:"100px"}}>
          Back To Home Page
        </button>
    
  </div>
);
}

export default AudioTrustPanel;
